import ParticipantGroup from "../participant-group/ParticipantGroup";
import Person from "../person/Person";
import Group from './Group';

export default class GroupRegistrationRequest implements Group{
    id: number;
    name: string;
    associationActivityId: number;
    associationId: number;
    participantGroups: ParticipantGroup[];
    isDeleted: boolean;
    confirmEmailUrl: string;

    constructor(
        name: string,
        associationActivityId: number,
        associationId: number,
        participantGroups: ParticipantGroup[],
        confirmEmailUrl: string,
    ) {
        this.name = name;
        this.associationId = associationId;
        this.associationActivityId = associationActivityId;
        this.participantGroups = participantGroups;
        this.confirmEmailUrl = confirmEmailUrl;

        this.isDeleted = false;
        this.id = 0;
    }
}